<template>
  <div class="top-bar">
    <b-navbar
      toggleable="lg"
      class="nav-item-content d-flex justify-content-between align-items-center"
    >
      <div class="d-flex justify-content-start align-items-center">
        <svg
          class="logo-large"
          width="120"
          height="40"
          viewBox="0 0 120 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M30.5713 24.0604C32.8166 24.0604 34.6368 22.2425 34.6368 19.9999C34.6368 17.7574 32.8166 15.9395 30.5713 15.9395C28.326 15.9395 26.5059 17.7574 26.5059 19.9999C26.5059 22.2425 28.326 24.0604 30.5713 24.0604Z"
              fill="var(--theme-color)"
            />
            <path
              d="M40 20C40 14.8138 35.8021 10.6064 30.6148 10.584V13.8669C33.9865 13.8894 36.713 16.6272 36.713 20C36.713 23.3728 33.9865 26.1105 30.6148 26.133H29.4271C27.6115 26.133 26.1401 27.6026 26.1401 29.4159H30.6148C35.8021 29.3935 40 25.1861 40 20Z"
              fill="var(--theme-color)"
            />
            <path
              d="M0 20C0 25.1861 4.19783 29.3935 9.38521 29.4159V26.133C6.01346 26.1105 3.28699 23.3728 3.28699 20C3.28699 16.6272 6.01346 13.8894 9.38521 13.8669H10.5729C12.3885 13.8669 13.8598 12.3974 13.8598 10.584H9.38521C4.19783 10.6064 0 14.8138 0 20Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9994 40C25.1919 40 29.4045 35.8073 29.427 30.6263H26.14C26.1175 33.9939 23.3763 36.7171 19.9994 36.7171C16.6224 36.7171 13.8813 33.9939 13.8588 30.6263V29.4402C13.8588 27.6268 12.3874 26.1572 10.5718 26.1572V30.6263C10.5943 35.8073 14.8068 40 19.9994 40Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9996 13.4773C22.2449 13.4773 24.065 11.6593 24.065 9.4168C24.065 7.17426 22.2449 5.35632 19.9996 5.35632C17.7543 5.35632 15.9341 7.17426 15.9341 9.4168C15.9341 11.6593 17.7543 13.4773 19.9996 13.4773Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9996 34.6437C22.2449 34.6437 24.065 32.8257 24.065 30.5832C24.065 28.3406 22.2449 26.5227 19.9996 26.5227C17.7543 26.5227 15.9341 28.3406 15.9341 30.5832C15.9341 32.8257 17.7543 34.6437 19.9996 34.6437Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9994 0C14.8068 0 10.5943 4.19266 10.5718 9.37365H13.8588C13.8813 6.00605 16.6224 3.28294 19.9994 3.28294C23.3763 3.28294 26.1175 6.00605 26.14 9.37365V10.5598C26.14 12.3732 27.6113 13.8428 29.427 13.8428V9.37365C29.4045 4.19266 25.1919 0 19.9994 0Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9997 24.7517C22.6272 24.7517 24.7572 22.6243 24.7572 20C24.7572 17.3758 22.6272 15.2484 19.9997 15.2484C17.3722 15.2484 15.2422 17.3758 15.2422 20C15.2422 22.6243 17.3722 24.7517 19.9997 24.7517Z"
              fill="var(--theme-color)"
            />
            <path
              d="M9.40337 24.0604C11.6487 24.0604 13.4689 22.2425 13.4689 19.9999C13.4689 17.7574 11.6487 15.9395 9.40337 15.9395C7.15807 15.9395 5.33789 17.7574 5.33789 19.9999C5.33789 22.2425 7.15807 24.0604 9.40337 24.0604Z"
              fill="var(--theme-color)"
            />
          </g>
          <path
            d="M56.368 24.612C55.668 24.612 54.996 24.5093 54.352 24.304C53.7173 24.0893 53.2087 23.8047 52.826 23.45C52.686 23.3193 52.616 23.156 52.616 22.96C52.616 22.8293 52.6533 22.7173 52.728 22.624C52.8027 22.5213 52.8913 22.47 52.994 22.47C53.1153 22.47 53.246 22.5213 53.386 22.624C54.254 23.296 55.2433 23.632 56.354 23.632C57.1567 23.632 57.7727 23.478 58.202 23.17C58.6313 22.862 58.846 22.4233 58.846 21.854C58.846 21.5273 58.7433 21.266 58.538 21.07C58.3327 20.8647 58.062 20.7013 57.726 20.58C57.39 20.4587 56.9373 20.3327 56.368 20.202C55.6027 20.0247 54.9727 19.838 54.478 19.642C53.9927 19.446 53.596 19.166 53.288 18.802C52.9893 18.438 52.84 17.962 52.84 17.374C52.84 16.814 52.9893 16.3193 53.288 15.89C53.596 15.4513 54.0207 15.1153 54.562 14.882C55.1127 14.6393 55.738 14.518 56.438 14.518C57.0913 14.518 57.698 14.6207 58.258 14.826C58.8273 15.022 59.3033 15.3067 59.686 15.68C59.8353 15.8293 59.91 15.9927 59.91 16.17C59.91 16.3007 59.8727 16.4173 59.798 16.52C59.7233 16.6133 59.6347 16.66 59.532 16.66C59.4293 16.66 59.294 16.6087 59.126 16.506C58.6687 16.1327 58.244 15.8713 57.852 15.722C57.46 15.5727 56.9887 15.498 56.438 15.498C55.6633 15.498 55.0613 15.6613 54.632 15.988C54.2027 16.3053 53.988 16.7533 53.988 17.332C53.988 17.8267 54.1747 18.2 54.548 18.452C54.9307 18.6947 55.514 18.9093 56.298 19.096C57.1473 19.3013 57.8147 19.4927 58.3 19.67C58.7853 19.838 59.1867 20.0947 59.504 20.44C59.8307 20.7853 59.994 21.2473 59.994 21.826C59.994 22.3767 59.84 22.862 59.532 23.282C59.2333 23.702 58.8087 24.0287 58.258 24.262C57.7073 24.4953 57.0773 24.612 56.368 24.612ZM62.4466 24.5C62.2693 24.5 62.1246 24.4487 62.0126 24.346C61.91 24.2433 61.8586 24.108 61.8586 23.94V15.19C61.8586 15.022 61.91 14.8867 62.0126 14.784C62.1246 14.6813 62.2693 14.63 62.4466 14.63H67.6826C67.8506 14.63 67.9813 14.672 68.0746 14.756C68.168 14.84 68.2146 14.9567 68.2146 15.106C68.2146 15.2553 68.168 15.372 68.0746 15.456C67.9813 15.54 67.8506 15.582 67.6826 15.582H62.9926V19.012H67.4026C67.5706 19.012 67.7013 19.054 67.7946 19.138C67.888 19.222 67.9346 19.3387 67.9346 19.488C67.9346 19.6373 67.888 19.754 67.7946 19.838C67.7013 19.922 67.5706 19.964 67.4026 19.964H62.9926V23.548H67.6826C67.8506 23.548 67.9813 23.59 68.0746 23.674C68.168 23.7487 68.2146 23.8653 68.2146 24.024C68.2146 24.1733 68.168 24.29 68.0746 24.374C67.9813 24.458 67.8506 24.5 67.6826 24.5H62.4466ZM73.0203 24.612C72.3203 24.612 71.6483 24.5093 71.0043 24.304C70.3697 24.0893 69.861 23.8047 69.4783 23.45C69.3383 23.3193 69.2683 23.156 69.2683 22.96C69.2683 22.8293 69.3057 22.7173 69.3803 22.624C69.455 22.5213 69.5437 22.47 69.6463 22.47C69.7677 22.47 69.8983 22.5213 70.0383 22.624C70.9063 23.296 71.8957 23.632 73.0063 23.632C73.809 23.632 74.425 23.478 74.8543 23.17C75.2837 22.862 75.4983 22.4233 75.4983 21.854C75.4983 21.5273 75.3957 21.266 75.1903 21.07C74.985 20.8647 74.7143 20.7013 74.3783 20.58C74.0423 20.4587 73.5897 20.3327 73.0203 20.202C72.255 20.0247 71.625 19.838 71.1303 19.642C70.645 19.446 70.2483 19.166 69.9403 18.802C69.6417 18.438 69.4923 17.962 69.4923 17.374C69.4923 16.814 69.6417 16.3193 69.9403 15.89C70.2483 15.4513 70.673 15.1153 71.2143 14.882C71.765 14.6393 72.3903 14.518 73.0903 14.518C73.7437 14.518 74.3503 14.6207 74.9103 14.826C75.4797 15.022 75.9557 15.3067 76.3383 15.68C76.4877 15.8293 76.5623 15.9927 76.5623 16.17C76.5623 16.3007 76.525 16.4173 76.4503 16.52C76.3757 16.6133 76.287 16.66 76.1843 16.66C76.0817 16.66 75.9463 16.6087 75.7783 16.506C75.321 16.1327 74.8963 15.8713 74.5043 15.722C74.1123 15.5727 73.641 15.498 73.0903 15.498C72.3157 15.498 71.7137 15.6613 71.2843 15.988C70.855 16.3053 70.6403 16.7533 70.6403 17.332C70.6403 17.8267 70.827 18.2 71.2003 18.452C71.583 18.6947 72.1663 18.9093 72.9503 19.096C73.7997 19.3013 74.467 19.4927 74.9523 19.67C75.4377 19.838 75.839 20.0947 76.1563 20.44C76.483 20.7853 76.6463 21.2473 76.6463 21.826C76.6463 22.3767 76.4923 22.862 76.1843 23.282C75.8857 23.702 75.461 24.0287 74.9103 24.262C74.3597 24.4953 73.7297 24.612 73.0203 24.612ZM81.661 24.612C80.961 24.612 80.289 24.5093 79.645 24.304C79.0103 24.0893 78.5016 23.8047 78.119 23.45C77.979 23.3193 77.909 23.156 77.909 22.96C77.909 22.8293 77.9463 22.7173 78.021 22.624C78.0956 22.5213 78.1843 22.47 78.287 22.47C78.4083 22.47 78.539 22.5213 78.679 22.624C79.547 23.296 80.5363 23.632 81.647 23.632C82.4496 23.632 83.0656 23.478 83.495 23.17C83.9243 22.862 84.139 22.4233 84.139 21.854C84.139 21.5273 84.0363 21.266 83.831 21.07C83.6256 20.8647 83.355 20.7013 83.019 20.58C82.683 20.4587 82.2303 20.3327 81.661 20.202C80.8956 20.0247 80.2656 19.838 79.771 19.642C79.2856 19.446 78.889 19.166 78.581 18.802C78.2823 18.438 78.133 17.962 78.133 17.374C78.133 16.814 78.2823 16.3193 78.581 15.89C78.889 15.4513 79.3136 15.1153 79.855 14.882C80.4056 14.6393 81.031 14.518 81.731 14.518C82.3843 14.518 82.991 14.6207 83.551 14.826C84.1203 15.022 84.5963 15.3067 84.979 15.68C85.1283 15.8293 85.203 15.9927 85.203 16.17C85.203 16.3007 85.1656 16.4173 85.091 16.52C85.0163 16.6133 84.9276 16.66 84.825 16.66C84.7223 16.66 84.587 16.6087 84.419 16.506C83.9616 16.1327 83.537 15.8713 83.145 15.722C82.753 15.5727 82.2816 15.498 81.731 15.498C80.9563 15.498 80.3543 15.6613 79.925 15.988C79.4956 16.3053 79.281 16.7533 79.281 17.332C79.281 17.8267 79.4676 18.2 79.841 18.452C80.2236 18.6947 80.807 18.9093 81.591 19.096C82.4403 19.3013 83.1076 19.4927 83.593 19.67C84.0783 19.838 84.4796 20.0947 84.797 20.44C85.1236 20.7853 85.287 21.2473 85.287 21.826C85.287 22.3767 85.133 22.862 84.825 23.282C84.5263 23.702 84.1016 24.0287 83.551 24.262C83.0003 24.4953 82.3703 24.612 81.661 24.612ZM87.7256 24.57C87.5483 24.57 87.4083 24.5187 87.3056 24.416C87.2029 24.304 87.1516 24.1593 87.1516 23.982V15.148C87.1516 14.9707 87.2029 14.8307 87.3056 14.728C87.4083 14.616 87.5483 14.56 87.7256 14.56C87.9029 14.56 88.0429 14.616 88.1456 14.728C88.2483 14.8307 88.2996 14.9707 88.2996 15.148V23.982C88.2996 24.1593 88.2483 24.304 88.1456 24.416C88.0429 24.5187 87.9029 24.57 87.7256 24.57ZM94.8636 24.612C93.949 24.612 93.151 24.4067 92.4696 23.996C91.7976 23.5853 91.2796 23.002 90.9156 22.246C90.5516 21.49 90.3696 20.5987 90.3696 19.572C90.3696 18.536 90.547 17.64 90.9016 16.884C91.2656 16.1187 91.7836 15.5353 92.4556 15.134C93.137 14.7233 93.9396 14.518 94.8636 14.518C95.7876 14.518 96.5856 14.7233 97.2576 15.134C97.939 15.5353 98.457 16.1187 98.8116 16.884C99.1756 17.64 99.3576 18.5313 99.3576 19.558C99.3576 20.5847 99.1756 21.4807 98.8116 22.246C98.4476 23.002 97.925 23.5853 97.2436 23.996C96.5716 24.4067 95.7783 24.612 94.8636 24.612ZM94.8636 23.632C95.909 23.632 96.721 23.282 97.2996 22.582C97.8876 21.8727 98.1816 20.8647 98.1816 19.558C98.1816 18.2513 97.8923 17.248 97.3136 16.548C96.735 15.848 95.9183 15.498 94.8636 15.498C93.8183 15.498 93.0016 15.8527 92.4136 16.562C91.835 17.262 91.5456 18.2607 91.5456 19.558C91.5456 20.8553 91.835 21.8587 92.4136 22.568C93.0016 23.2773 93.8183 23.632 94.8636 23.632ZM108.803 14.56C108.971 14.56 109.102 14.616 109.195 14.728C109.288 14.8307 109.335 14.9707 109.335 15.148V23.982C109.335 24.1593 109.284 24.304 109.181 24.416C109.088 24.5187 108.952 24.57 108.775 24.57C108.598 24.57 108.444 24.4907 108.313 24.332L102.503 16.562V23.982C102.503 24.1593 102.452 24.304 102.349 24.416C102.256 24.5187 102.125 24.57 101.957 24.57C101.789 24.57 101.658 24.5187 101.565 24.416C101.472 24.304 101.425 24.1593 101.425 23.982V15.148C101.425 14.9707 101.472 14.8307 101.565 14.728C101.668 14.616 101.808 14.56 101.985 14.56C102.172 14.56 102.33 14.6393 102.461 14.798L108.257 22.568V15.148C108.257 14.9707 108.304 14.8307 108.397 14.728C108.5 14.616 108.635 14.56 108.803 14.56ZM114.925 24.612C114.225 24.612 113.553 24.5093 112.909 24.304C112.274 24.0893 111.765 23.8047 111.383 23.45C111.243 23.3193 111.173 23.156 111.173 22.96C111.173 22.8293 111.21 22.7173 111.285 22.624C111.359 22.5213 111.448 22.47 111.551 22.47C111.672 22.47 111.803 22.5213 111.943 22.624C112.811 23.296 113.8 23.632 114.911 23.632C115.713 23.632 116.329 23.478 116.759 23.17C117.188 22.862 117.403 22.4233 117.403 21.854C117.403 21.5273 117.3 21.266 117.095 21.07C116.889 20.8647 116.619 20.7013 116.283 20.58C115.947 20.4587 115.494 20.3327 114.925 20.202C114.159 20.0247 113.529 19.838 113.035 19.642C112.549 19.446 112.153 19.166 111.845 18.802C111.546 18.438 111.397 17.962 111.397 17.374C111.397 16.814 111.546 16.3193 111.845 15.89C112.153 15.4513 112.577 15.1153 113.119 14.882C113.669 14.6393 114.295 14.518 114.995 14.518C115.648 14.518 116.255 14.6207 116.815 14.826C117.384 15.022 117.86 15.3067 118.243 15.68C118.392 15.8293 118.467 15.9927 118.467 16.17C118.467 16.3007 118.429 16.4173 118.355 16.52C118.28 16.6133 118.191 16.66 118.089 16.66C117.986 16.66 117.851 16.6087 117.683 16.506C117.225 16.1327 116.801 15.8713 116.409 15.722C116.017 15.5727 115.545 15.498 114.995 15.498C114.22 15.498 113.618 15.6613 113.189 15.988C112.759 16.3053 112.545 16.7533 112.545 17.332C112.545 17.8267 112.731 18.2 113.105 18.452C113.487 18.6947 114.071 18.9093 114.855 19.096C115.704 19.3013 116.371 19.4927 116.857 19.67C117.342 19.838 117.743 20.0947 118.061 20.44C118.387 20.7853 118.551 21.2473 118.551 21.826C118.551 22.3767 118.397 22.862 118.089 23.282C117.79 23.702 117.365 24.0287 116.815 24.262C116.264 24.4953 115.634 24.612 114.925 24.612Z"
            fill="#474D52"
          />
          <defs>
            <clipPath id="clip0">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <svg
          class="logo-small"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M30.5713 24.0604C32.8166 24.0604 34.6368 22.2425 34.6368 19.9999C34.6368 17.7574 32.8166 15.9395 30.5713 15.9395C28.326 15.9395 26.5059 17.7574 26.5059 19.9999C26.5059 22.2425 28.326 24.0604 30.5713 24.0604Z"
              fill="var(--theme-color)"
            />
            <path
              d="M40 20C40 14.8138 35.8021 10.6064 30.6148 10.584V13.8669C33.9865 13.8894 36.713 16.6272 36.713 20C36.713 23.3728 33.9865 26.1105 30.6148 26.133H29.4271C27.6115 26.133 26.1401 27.6026 26.1401 29.4159H30.6148C35.8021 29.3935 40 25.1861 40 20Z"
              fill="var(--theme-color)"
            />
            <path
              d="M0 20C0 25.1861 4.19783 29.3935 9.38521 29.4159V26.133C6.01346 26.1105 3.28699 23.3728 3.28699 20C3.28699 16.6272 6.01346 13.8894 9.38521 13.8669H10.5729C12.3885 13.8669 13.8598 12.3974 13.8598 10.584H9.38521C4.19783 10.6064 0 14.8138 0 20Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9994 40C25.1919 40 29.4045 35.8073 29.427 30.6263H26.14C26.1175 33.9939 23.3763 36.7171 19.9994 36.7171C16.6224 36.7171 13.8813 33.9939 13.8588 30.6263V29.4402C13.8588 27.6268 12.3874 26.1572 10.5718 26.1572V30.6263C10.5943 35.8073 14.8068 40 19.9994 40Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9996 13.4773C22.2449 13.4773 24.065 11.6593 24.065 9.4168C24.065 7.17426 22.2449 5.35632 19.9996 5.35632C17.7543 5.35632 15.9341 7.17426 15.9341 9.4168C15.9341 11.6593 17.7543 13.4773 19.9996 13.4773Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9996 34.6437C22.2449 34.6437 24.065 32.8257 24.065 30.5832C24.065 28.3406 22.2449 26.5227 19.9996 26.5227C17.7543 26.5227 15.9341 28.3406 15.9341 30.5832C15.9341 32.8257 17.7543 34.6437 19.9996 34.6437Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9994 0C14.8068 0 10.5943 4.19266 10.5718 9.37365H13.8588C13.8813 6.00605 16.6224 3.28294 19.9994 3.28294C23.3763 3.28294 26.1175 6.00605 26.14 9.37365V10.5598C26.14 12.3732 27.6113 13.8428 29.427 13.8428V9.37365C29.4045 4.19266 25.1919 0 19.9994 0Z"
              fill="var(--theme-color)"
            />
            <path
              d="M19.9997 24.7517C22.6272 24.7517 24.7572 22.6243 24.7572 20C24.7572 17.3758 22.6272 15.2484 19.9997 15.2484C17.3722 15.2484 15.2422 17.3758 15.2422 20C15.2422 22.6243 17.3722 24.7517 19.9997 24.7517Z"
              fill="var(--theme-color)"
            />
            <path
              d="M9.40337 24.0604C11.6487 24.0604 13.4689 22.2425 13.4689 19.9999C13.4689 17.7574 11.6487 15.9395 9.40337 15.9395C7.15807 15.9395 5.33789 17.7574 5.33789 19.9999C5.33789 22.2425 7.15807 24.0604 9.40337 24.0604Z"
              fill="var(--theme-color)"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="countdown" v-if="countDown">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
            fill="#B3C2CB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 5C12.5523 5 13 5.44772 13 6V11.382L16.4472 13.1056C16.9412 13.3526 17.1414 13.9532 16.8944 14.4472C16.6474 14.9412 16.0468 15.1414 15.5528 14.8944L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V6C11 5.44772 11.4477 5 12 5Z"
            fill="#B3C2CB"
          />
        </svg>
        {{ countDown }}
      </div>
      <div class="actions d-flex justify-content-around align-items-center">
        <div class="localtime" v-if="localtime">
          <!-- <span v-if="name" class="textual">{{ name }}'s local time </span> -->
          <span class="textual">User's local time </span>
          <span>{{ localtime }}</span>
        </div>
        <div class="profile">
          <div @click="profilePanel = !profilePanel">
            <span class="username">
              <span v-if="name">
                {{ name }}
              </span>
              <span v-else>
                Guest User
              </span>
              <img
                v-if="$store.getters['user/profile'].imgURL"
                :src="$store.getters['user/profile'].imgURL"
                style="height:40px;width:40px;border-radius:50%;"
              />
              <a-avatar v-else shape="circle" icon="user" :size="35" />
            </span>
          </div>
          <div
            class="overlay"
            v-if="profilePanel"
            @click="profilePanel = false"
          ></div>
          <transition v-if="true" name="fade">
            <div class="profile-panel" v-if="profilePanel">
              <ul>
                <li class="item" @click="handleToggleCanvas">
                  <span> Canvas</span>
                </li>
                <div class="divider"></div>
                <li
                  class="item"
                  @click="handleConjureClick('fireworks', 10000)"
                >
                  <span>Fireworks</span>
                </li>
                <li class="item" @click="handleConjureClick('circle', 3000)">
                  <span>Celebrate Circle</span>
                </li>
                <li class="item" @click="handleConjureClick('rect', 3000)">
                  <span>Celebrate Rect</span>
                </li>
                <li class="item" @click="handleConjureClick('heart', 3000)">
                  <span>Celebrate Heart</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </b-navbar>

    <b-modal
      size="md"
      title="Session Code"
      hide-footer
      centered
      v-model="showGenerateSessionCode"
    >
      <div v-if="sessionURL">
        {{ sessionURL }}
      </div>
      <b-button v-else @click="handlegenerateSessionCodeClick">
        Generate Code
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import moment from "moment";

export default {
  name: "session-navbar",
  props: {
    name: {
      type: String,
      required: false
    },
    localtime: {
      required: false
    },
    roomId: {
      type: String,
      required: false
    },
    countDown: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      present: "session/present"
    }),
    // countDown() {
    //   return "00:30:29";
    // },
    user() {
      return this.$store.state.user;
    },
    sessionURL() {
      return this.generatedSessionCode
        ? `https://journeybinder.com/sessions/${this.generatedSessionCode}`
        : null;
    }
  },
  mounted() {},
  methods: {
    handleToggleCanvas() {
      this.canvasModalIsOpenState = this.canvasModalIsOpenState ? false : true;

      let payload = {
        roomId: this.roomId,
        userId: this.$store.getters[`user/user`].uid,
        isOpen: this.canvasModalIsOpenState
      };

      this.$store
        .dispatch("session/setCanvasIsOpen", payload)
        .then(data => {})
        .catch(error => {});
    },
    handleConjureClick(type, interval) {
      let payload = {
        roomId: this.roomId,
        userId: this.$store.getters[`user/user`].uid,
        type: type,
        interval: interval
      };

      this.$store
        .dispatch("session/setConjure", payload)
        .then(data => {})
        .catch(error => {});
    },
    handlegenerateSessionCodeClick() {}
  },
  data() {
    return {
      profilePanel: false,
      canvasModalIsOpenState: false,
      showGenerateSessionCode: false,
      generatedSessionCode: null
    };
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 60px;
  box-shadow: 0px -2px 8px 0px #ccc;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  background: white;
  z-index: 7;
  margin-bottom: 15px;
  .logo-small {
    display: none;
  }
  .nav-item-content {
    width: 100%;
    padding: 0 20px;
  }
  .qoute {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .qoute-coma {
      margin-top: -2px;
      margin-right: 10px;
    }
    h4 {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      margin: 0;
    }
  }
  .hamburger {
    margin: 0 10px;
    cursor: pointer;
  }
  .countdown {
    margin-left: 16%;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 38px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #ef5c4a;
    svg {
      margin-right: 10px;
    }
  }
  .localtime {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    // color: #8D99A0;
    color: #474d52;
    text-transform: capitalize;
    .textual {
      font-size: 16px;
      line-height: 22px;
      color: #8d99a0;
    }
  }
  .actions {
    button,
    div {
      margin: 0 10px;
    }

    button {
      padding: 8px 15px;
      font-size: 16px;
      line-height: 22px;
      height: 44px;
      .text {
        margin-left: 3px;
      }
    }
    .overlay {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(189, 189, 189, 0);
      z-index: 8;
    }
    .notification {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      span {
        cursor: pointer;
      }
      .red-dot {
        position: absolute;
        top: -6px;
        left: 50%;
      }

      .notifications-panel {
        z-index: 10;
        padding: 20px 10px;
        position: absolute;
        border-radius: 10px;
        width: 316px;
        top: 47px;
        right: -100px;
        background-color: #fff;
        box-shadow: 0px 0px 8px 0 #eee;
        div {
          margin: 0;
        }
        .title {
          font-weight: bold;
          font-size: 14px;
          line-height: 19px;
          /* identical to box height */

          /* Secondary */

          color: #8d99a0;
        }
        .see-all {
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          /* identical to box height */

          /* Primary */

          color: var(--theme-color);
          text-decoration: none;
        }
        .noti-msg {
          padding: 10px 0;
          border-top: 2px solid #d9d9d9;
          &.no-border {
            border: none;
          }
          display: grid;
          grid-template-columns: 45px 1fr;
          .name {
            font-size: 14px;
            line-height: 19px;
            font-weight: bold;
            color: #474d52;
          }
          .time {
            font-family: "Nunito", sans-serif;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #8d99a0;
          }
          .usr-msg {
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            color: #474d52;
            /*margin-top: 6px;*/
          }
          .btn-fill,
          .btn-outline {
            /*margin-top: 12px;*/
            margin-left: 0;
            padding: 5px 15px;
            border-radius: 5px;
            text-decoration: none;
            font-weight: normal;
            font-size: 14px;
          }
          .btn-outline {
            border: none;
            &:hover {
              color: var(--theme-color);
            }
          }
          .btn-fill {
            &:hover {
              color: #fff;
            }
          }
          .usr-img {
            img {
              height: 40px;
              width: 40px;
              object-fit: cover;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .profile {
      position: relative;
      & > div {
        cursor: pointer;
      }

      img {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
        margin-left: 10px;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        font-family: "Nunito", sans-serif;
        color: #474d52;
      }
      .profile-panel {
        z-index: 10;
        position: absolute;
        top: 40px;
        right: -25px;
        background-color: #fff;
        padding: 10px 5px;
        width: 205px;
        box-shadow: 0px 0px 8px 0 #eee;
        border-radius: 10px;

        ul {
          padding: 0;
          list-style-type: none;
          li {
            display: block;
            padding: 8px;
            a {
              font-weight: 700;
              text-decoration: none;
              font-family: "Nunito", sans-serif;

              span {
                font-size: 14px;
                line-height: 19px;
                color: #474d52;
                margin: 0;
                margin-left: 10px;
              }
              &:hover {
                box-shadow: none !important;
              }
            }

            &.logout {
              color: red;
              span {
                margin-left: 10px;
              }
            }
          }
          .divider {
            border-top: 1px solid #b3c2cb;
            width: 205px;
            margin-left: -6px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 1500px) {
  .qoute {
    h4 {
      /*display: none;*/
    }
  }
}
@media (max-width: 1440px) {
  .qoute {
    h4 {
      display: block;
    }
  }
}
@media (max-width: 1160px) {
  .top-bar {
    .qoute {
      h4 {
        display: none;
      }
      .qoute-coma {
        display: none;
      }
    }
    .hamburger {
      float: left !important;
    }
  }
  .localtime {
    .textual {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .actions {
    button {
      width: unset !important;
      .text {
        display: none;
      }
    }

    .username {
      display: none;
    }
  }
  .countdown {
    font-size: 14px !important;
    margin-left: 5% !important;
  }
}

@media (max-width: 558px) {
  .localtime {
    display: none;
  }
  .logo-small {
    display: block !important;
  }
  .logo-large {
    display: none !important;
  }
  .top-bar .actions button,
  .top-bar .actions div {
    margin: 0 4px;
  }
  .top-bar .actions button {
    padding: 4px 10px;
  }
  .top-bar .actions .notification {
    /*position: unset;*/
    .notifications-panel {
      position: fixed;
      width: 100%;
      right: 0;
      left: 0;
      top: 60px;
      bottom: 0;
    }
  }
  .top-bar .actions .profile .profile-panel {
    right: 0;
  }
}

/*button:hover,*/
/*a:hover{*/
/*    box-shadow: 0px 2px 6px 0px #cbcbcb;*/
/*    cursor: pointer;*/
/*}*/
</style>
